import React, { useState, useEffect, useRef } from 'react';
import QRCode from 'react-qr-code';
import { getUrlParam } from '../../utils/url.utils';
import EventLabel from '../../components/EventLabel/EventLabel';

const QR = ({ settings, setAspectRatio }) => {
  const { useBadgeNo, content } = settings;

  const [badgeNumber, setbadgeNumber] = useState('No badge number');
  const [display, setDisplay] = useState('No badge number');

  const wrapRef = useRef();
  let padding = 0;

  useEffect(() => {
    if (useBadgeNo) {
      let badgeNum = getUrlParam('badgeno');
      if (!badgeNum) {
        badgeNum = getUrlParam('clientkey');
      }
      setbadgeNumber(badgeNum);
      setDisplay(badgeNum);
    } else if (content) {
      let contentToLowerString = content.toLowerCase();

      if (contentToLowerString.includes('[clientkey]')) {
        contentToLowerString = contentToLowerString.replace('[clientkey]', getUrlParam('clientkey'));
      }

      if (contentToLowerString.includes('[badgeno]')) {
        contentToLowerString = contentToLowerString.replace('[badgeno]', getUrlParam('badgeno'));
      }

      setDisplay(contentToLowerString);
    }
  }, [content, useBadgeNo]);

  if (wrapRef.current) {
    var elStyle = window.getComputedStyle(wrapRef.current);
    padding = parseFloat(elStyle.paddingTop.replace('px', '')) + parseFloat(elStyle.paddingBottom.replace('px', ''));
  }

  if (useBadgeNo && !badgeNumber) {
    return (
      <div ref={wrapRef}>
        <EventLabel name="QRMissingBadgeNo" groupName={'Content.StaticLabels'} />
      </div>
    );
  } else if (!useBadgeNo && !content) {
    return (
      <div ref={wrapRef}>
        <EventLabel name="QRMissingContent" groupName={'Content.StaticLabels'} />
      </div>
    );
  }

  return (
    <div ref={wrapRef} className={'qr-wrap'}>
      <QRCode size={(wrapRef.current?.clientHeight || 150) - padding} value={display} />
    </div>
  );
};

export default QR;
